import { batch, useDispatch } from 'react-redux';
import { ActiveAuthForm } from '../../../../../store/auth/enum/active-auth-form';
import { createSetActiveAuthForm } from '../../../../../store/auth/factory';
import { setModalAction } from '../../../../../store/modal/factory';
import { ActiveModal } from '../../../../enums/active-modal';

export function useViewModel() {
  const dispatch = useDispatch();

  const redirectToRegisterHandler = () => {
      return document.location.href = `${window.location.origin}/?showModal=register`;
  }
  const redirectToLoginHandler = () => {
      return document.location.href = `${window.location.origin}/?showModal=login`;
  }

  const loginClickHandler = () =>  
    batch(() => {
      dispatch(createSetActiveAuthForm(ActiveAuthForm.LOGIN));
      dispatch(setModalAction(ActiveModal.LOGIN));
    });

  const registerClickHandler = () =>
    batch(() => {
      // dispatch(createSetActiveAuthForm(ActiveAuthForm.REGISTER));
      dispatch(setModalAction(ActiveModal.ROLE));
    });

  return {
    redirectToRegisterHandler,
    redirectToLoginHandler,
    loginClickHandler,
    registerClickHandler,
  };
}
